import React from 'preact/compat';
import { ComponentChildren } from 'preact';
import AriaModal from 'react-aria-modal';
import { getApplicationNode } from './util';
import CloseIcon from '../icons/close';
export { useDialog } from './hooks';

export default function Dialog({ children, shown, close, ...rest }: DialogProps) {
    if (!shown) {
        return null;
    }

    return (
        <AriaModal
            focusDialog={true}
            getApplicationNode={getApplicationNode}
            includeDefaultStyles={false}
            underlayClass='dialog'
            dialogClass='window'
            onExit={close}
            scrollDisabled={false}
            {...rest}>
            <div className='wrapper  window__content'>
                {children}
            </div>
        </AriaModal>
    );
}

Dialog.Close = CloseButton;
Dialog.Heading = Heading;
Dialog.Footer = Footer;

type DialogProps = {
    children?: ComponentChildren,
    titleId: string,
    shown: boolean,
    close?: () => void,
};

function CloseButton({ onClick }: CloseButtonProps) {
    return (
        <button type='button' onClick={onClick} className='window__close'>
            <CloseIcon fill='currentColor' />
        </button>
    );
}

type CloseButtonProps = {
    onClick: () => void,
};

function Heading({ id, children, className = '' }: HeadingProps) {
    return (
        <h2 id={id} className={`${className} window__title`}>
            {children}
        </h2>
    );
}

type HeadingProps = {
    id?: string,
    children?: ComponentChildren,
    className?: string,
};

function Footer({ children }: FooterProps) {
    return (
        <div className='window__footer'>
            {children}
        </div>
    )
}

type FooterProps = {
    children?: ComponentChildren,
};
